import { render } from "./LootDetailsModal.vue?vue&type=template&id=dbaef258&scoped=true"
import script from "./LootDetailsModal.vue?vue&type=script&lang=js"
export * from "./LootDetailsModal.vue?vue&type=script&lang=js"

import "./LootDetailsModal.vue?vue&type=style&index=0&id=dbaef258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbaef258"]])

export default __exports__